import { useState, useEffect } from 'react';

export interface ResponsiveInfo {
  width: number;
  isMobile: boolean;   // < 768
  isTablet: boolean;   // 768–1024
  isDesktop: boolean;  // > 1024
}

export function useResponsive(): ResponsiveInfo {
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    let raf: number;
    const handleResize = () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => setWidth(window.innerWidth));
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
      cancelAnimationFrame(raf);
    };
  }, []);

  return {
    width,
    isMobile: width < 768,
    isTablet: width >= 768 && width <= 1024,
    isDesktop: width > 1024,
  };
}

/**
 * Returns a responsive grid-template-columns value.
 * Usage: gridCols('repeat(6, 1fr)', 'repeat(3, 1fr)', 'repeat(2, 1fr)')
 */
export function useGridCols(desktop: string, tablet?: string, mobile?: string): string {
  const { isMobile, isTablet } = useResponsive();
  if (isMobile && mobile) return mobile;
  if (isTablet && tablet) return tablet || desktop;
  return desktop;
}
